//
// Copyright (c) 2011-2024 by Curalate, Inc.
//

import {
  InstagramUniversalPostType,
  UniversalPostType,
} from '@apis/universal-posts/universalPostsApiModel';

export const TAB_WIDTH = 135;

export const ALARM_INDICATOR_SIZE = 16;
export const CHECKMARK_ICON_SIZE = 16;
export const UNREAD_INDICATOR_SIZE = 8;
export const ALERT_BOX_SIZE = 562;

export const DEFAULT_INSTAGRAM_POST_TYPE: InstagramUniversalPostType =
  UniversalPostType.InstagramFeedAutomaticPost;

export const YOUTUBE_SHORTS_MAX_DURATION_IN_MILLIS = 3 * 60 * 1000;
